<template>
  <StickyTable class="customer-table" :header="header" :data="data" :annotations="annotations" :loading="busy">
    <template #header="{ item: { name, sum, aggregatedValue } }">
      <tr>
        <Cell th horizontal vertical class="toggle">
          <CheckIcon circle class="check-icon" :checkColor="'#5a5a5a'" circleColor="#fff" />
        </Cell>
        <Cell th horizontal vertical class="name">{{ name }}</Cell>
        <Cell th vertical class="sum">{{ sum }}</Cell>
        <Cell th vertical v-for="(item, key) in aggregatedValue" :key="key">{{ item }}</Cell>
      </tr>
    </template>
    <template #row="{ item: { id, name, sum, aggregatedValue, isShow }, annotation: { suffix, color }, index }">
      <tr :key="index">
        <Cell horizontal class="toggle" @click="toggle(id)">
          <CheckBox :checked="isShow" :color="color" />
        </Cell>
        <Cell horizontal class="name">{{ name }}</Cell>
        <Cell class="sum">
          {{ numberFormat(sum.qty) }}<span class="suffix">{{ suffix }}</span>
        </Cell>
        <Cell v-for="({ qty }, key) in aggregatedValue" :key="key">
          {{ numberFormat(qty) }}<span class="suffix">{{ suffix }}</span>
        </Cell>
      </tr>
    </template>
  </StickyTable>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { numberFormat, rateFormat } from '@/utils/number'
import CheckIcon from '@/components/icons/CheckIcon'
import StickyTable, { Cell } from '@/components/molecules/StickyTable'
import CheckBox from './CheckBox'

export default {
  name: 'CustomerTable',
  components: {
    CheckIcon,
    StickyTable,
    Cell,
    CheckBox,
  },
  props: {},
  data() {
    return {}
  },
  computed: {
    ...mapState({
      busy: state => state.analysis.customer.busy,
    }),
    ...mapGetters({
      header: 'analysis/customer/header',
      data: 'analysis/customer/data',
      colors: 'analysis/colors/customer',
    }),
    annotations() {
      const [shakespeare, seagull] = this.colors
      return [
        { suffix: '組', color: shakespeare },
        { suffix: '名', color: seagull },
      ]
    },
  },
  methods: {
    numberFormat,
    rateFormat,
    toggle(id) {
      this.$store.commit('analysis/customer/toggle', id)
    },
  },
}
</script>

<style scoped lang="postcss">
.customer-table {
  max-height: 600px;

  .check-icon {
    height: 20px;
    width: 20px;
  }

  td {
    text-align: right;

    &.toggle {
      cursor: pointer;
      padding: 0;
    }
    &.name {
      line-height: 1.3;
      padding: 0 8px;
      text-align: left;
    }
    &.sum {
      font-weight: 600;
    }

    .suffix {
      font-size: 10px;
      margin-left: 2px;
    }
  }

  .toggle {
    left: 0;
    line-height: 0;
    min-width: 40px;
    text-align: center;
  }

  .name {
    left: 40px;
    min-width: 106px;
  }
}
</style>
